import Api from '@/services/Api'

export default {
  register (credentials) {
    return Api().post('register', credentials)
  },
  login (credentials) {
    return Api().post('login', credentials)
  },
  test403 () {
    return Api().post('test403')
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js